export default __webpack_public_path__ + "static/media/modely3.43759c9d.jfif";